export default {
  edit_selection: 'Modifica selezione',
};
